import Vue from 'vue';

const userModule = {
	actions: {
		SET_BREAD_CRUMBS({ commit, state }, { fromRoute, toRoute, onlyRoute }) {
			localStorage.removeItem('bc');
			const existingIndex = state.breadCrumbs.findIndex(route => route.name === toRoute.name);
			let newBreadCrumbs = [];
			if (onlyRoute || toRoute.name === 'customers' || toRoute.name === 'accounting-accounts-by-subsidiary') {
				newBreadCrumbs = [toRoute];
				commit('SET_BREAD_CRUMBS', newBreadCrumbs);
			} else if (existingIndex === -1) {
				const toConcat = fromRoute.name === 'customers' ? fromRoute : state.breadCrumbs;
				newBreadCrumbs = [].concat(toConcat, toRoute);
				commit('SET_BREAD_CRUMBS', newBreadCrumbs);
			} else {
				const breadCrumbsSliced = state.breadCrumbs.slice(0, existingIndex + 1);
				newBreadCrumbs = [].concat(breadCrumbsSliced);
				commit('SET_BREAD_CRUMBS', newBreadCrumbs);
			}
			localStorage.setItem('bc', JSON.stringify(newBreadCrumbs));
		},
		LOCAL_STORAGE_BREAD_CRUMBS({ commit }, routeArray) {
			commit('SET_BREAD_CRUMBS', [].concat(routeArray));
		},
		UPDATE_BREAD_CRUMBS({ commit, getters }, currentSub) {
			const updatedBreadCrumbs = getters.getBreadCrumbs.reduce((list, item) => {
				if (item.params.subsidiaryId) {
					const { id, name } = currentSub;
					const newItem = { ...item };
					newItem.params.subsidiaryId = id;
					newItem.params.subsidiaryName = name.split(' ').join('-');
					return list.concat(newItem);
				}
				return list.concat(item);
			}, []);
			commit('SET_BREAD_CRUMBS', [].concat(updatedBreadCrumbs));
		},
	},
	getters: {
		getBreadCrumbs(state) {
			return state.breadCrumbs;
		},
	},
	mutations: {
		SET_BREAD_CRUMBS(state, routeArray) {
			Vue.set(state, 'breadCrumbs', routeArray);
		},
	},
	state: {
		breadCrumbs: [],
	},
};

export default userModule;



// WEBPACK FOOTER //
// ./src/store/modules/routing/routeModule.js